export default {
    irsSwitchLabelCustomStyle: {
        width: "28px",
        height: "14px",
    },
    irsSwitchButtonCustomStyle: {
        top: "1px",
        width: "10px",
        height: "10px",
    },
    // mainContainer: {
    //     height: '100%', 
    //     overflow: 'auto', 
    //     display: 'flex', 
    //     flexDirection: 'column'
    // }
}